/* ==========================================================================
   Verdelisse collection pages: visual behaviour only.
   - Filter links / sort form are real Shopify URLs (work without JS).
   - With JS, results are swapped in place using Shopify's Section Rendering API
     (same URL + section_id), like the source site's instant filtering.
   - Mobile filter drawer open/close.
   No cart or checkout code here.
   ========================================================================== */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  let loading = false;

  const shop = () => $('[data-vh-shop]');
  const drawerOpen = () => shop()?.querySelector('[data-vh-filters]')?.classList.contains('open');

  function setDrawer(open) {
    const root = shop(); if (!root) return;
    root.querySelector('[data-vh-filters]')?.classList.toggle('open', open);
    root.querySelector('[data-vh-fscrim]')?.classList.toggle('open', open);
    root.querySelector('[data-vh-filters-open]')?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('vh-locked', open);
  }

  async function load(url, push = true) {
    const root = shop();
    if (!root || loading) return;
    loading = true;
    const keepOpen = drawerOpen();
    root.querySelector('[data-vh-results]')?.classList.add('is-loading');
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', root.dataset.sectionId);
      const res = await fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-vh-shop]');
      if (!fresh) throw new Error('no section');
      root.replaceWith(fresh);
      if (push) history.pushState({ vhShop: true }, '', url);
      if (keepOpen) setDrawer(true);
    } catch (e) {
      location.href = url; // fall back to a normal page load
    } finally {
      loading = false;
    }
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-vh-shop] [data-vh-facet-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      load(link.href);
      return;
    }
    if (e.target.closest('[data-vh-filters-open]')) { setDrawer(true); return; }
    if (e.target.closest('[data-vh-filters-close], [data-vh-fscrim]')) { setDrawer(false); return; }
    if (e.target.closest('[data-vh-filters-done]')) {
      setDrawer(false);
      shop()?.querySelector('[data-vh-results]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // role="checkbox"/"radio" links: Space toggles like a real control
  document.addEventListener('keydown', (e) => {
    const t = e.target.closest?.('[data-vh-shop] [role="checkbox"], [data-vh-shop] [role="radio"]');
    if (t && e.key === ' ') { e.preventDefault(); t.click(); }
    if (e.key === 'Escape' && drawerOpen()) setDrawer(false);
  });

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-vh-shop] [data-vh-sort]');
    if (!sel) return;
    const form = sel.form;
    const params = new URLSearchParams(new FormData(form));
    load(`${form.action}?${params.toString()}`);
  });

  window.addEventListener('popstate', () => { if (shop()) load(location.href, false); });
})();
